import React, { Component } from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import withMobileDialog from "@material-ui/core/withMobileDialog";

import RecordsTable from "./RecordsTable.jsx";
import SearchComponent from "./SearchPanel.jsx";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import {connect} from "react-redux";
import {store} from "../../_store";
import {alertActions, commonActions} from "../../_actions";
import {commonService} from "../../_services";
import { appConstants } from "../../_constants";
import { EmptyRecord } from "../../utils/PageUtility";
import CircularProgress from "../../utils/CircularProgress";

const today = new Date();
let startDate = new Date();
startDate.setDate(today.getDate() - 30);

class AuditTrail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
        totalCount: 0,
      users: [],
        audits: [],
      auditModules: [],
      auditActions: [],
      allAuditActions: [],
       totalCounts: 0,
      StartDate: startDate,
      EndDate: today,
      records: [],
        currentPage: 1,
        pageSize: 10,
        searchParams: [],
        filterModes: [
            {Id: 1, Name: 'User', Value: 1},
            {Id: 2, Name: 'Module', Value: 2},
            {Id: 3, Name: 'Action', Value: 3},
            ],
        selectedFilterMode: '',
        searchBox: [],
        searchPayload: [],
        pageRequesting: true
    };
  }
  handleDateChange = (date, target) => {
    this.setState({ [target] : date });
  };
  handleAirlineChange = event => {
    this.setState({ selectedAirlineValue: event.target.value });
  };

  handleClickOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
  };

    componentDidMount() {
        let { users } = store.getState();
        const { dispatch } = this.props;
        if(users){
            users = this.packageUsers(users.ResultList);
            this.setState({users})
        }else{
            dispatch(commonActions.getAllUsers());
        }
        this.initializePageData();

    }
    componentWillReceiveProps = function (nextProps) {
        let { users } = nextProps;
        if(users){
            users = this.packageUsers(users.ResultList);
            this.setState({users});
        }
    };

    initializePageData = () => {
        const { dispatch } = this.props;
        dispatch(alertActions.startRequest());
        commonService.getAuditModules()
            .then(res =>{
             dispatch(alertActions.stopRequest());
            let response = res.response;
            if(res.status === appConstants.SUCCESS_RESPONSE) {
                this.setState({ auditModules: this.packageAuditModules(response) });
            }
            else if(res.status ===  appConstants.ERROR_RESPONSE){
                dispatch(alertActions.error(res.response));
            }
        });

        commonService.getAuditActions()
            .then(res =>{
             dispatch(alertActions.stopRequest());
            let response = res.response;
            if(res.status === appConstants.SUCCESS_RESPONSE) {
                this.setState({ auditActions: this.packageAuditActions(response) });
            }
            else if(res.status ===  appConstants.ERROR_RESPONSE){
                dispatch(alertActions.error(res.response));
            }
        });

        this.searchAudits();
    };

    packageUsers = (users) => {
      let data = [];
      users.map(item =>
          data.push({...item, type: 'USR', label: `${item.FirstName} ${item.LastName}`, value: item.Id})
      );
        return data;
    };
    packageAuditModules = (modules) => {
      let data = [];
      modules.map(item =>
          data.push({...item, type: 'MOD', label: `${item.ModuleName}`, value: item.ModuleId})
      );
      return data;
    };
    packageAuditActions = (actions) => {
      let data = [];
      actions.map(item =>
          data.push({...item, type: 'ACT', label: `${item.ActionName} ${(item.ModuleName) ? '(' + item.ModuleName + ')' : ''}`, value: item.ActionId})
      );
      return data;
    }
    searchAudits = (pageNumber) => {
        const {  searchParams, pageSize, StartDate, EndDate } = this.state;
        let params = {};
        for(let item of searchParams){
            if(item.type === 'USR'){
                params.UserId = item.Id
            }
            else if(item.type === 'MOD'){
                params.ModuleId = item.ModuleId
            }
            else if(item.type === 'ACT'){
                params.ActionId = item.ActionId
            }
        }
        const { dispatch } = this.props;
        let fromIndex = pageNumber;
        if(pageNumber === undefined){
            fromIndex = 1;
            pageNumber = 1;
        }

        let payload = {From: fromIndex, Size: pageSize, StartDate, EndDate, ...params };
        dispatch(alertActions.startRequest());
        commonService.searchAudits(payload)
            .then((res) => {
                dispatch(alertActions.stopRequest());
                let response = res.response;
                if(res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({ currentPage: pageNumber, pageRequesting: false, audits: response.AuditTrailEvents, totalCount: response.TotalCount });
                }
                else if(res.status === appConstants.ERROR_RESPONSE){
                    dispatch(alertActions.error(res.response));
                    this.setState({ pageRequesting: false});
                }
            });
    };
    handleMultiSelectChange = (value ) => {
        let currFilterValues = this.state.searchParams;
        if(currFilterValues.length === 0){
            let auditActions = [];
            if(value[0].type === "MOD"){
                 auditActions = this.packageAuditActions(value[0].AuditActions);
                this.setState({ auditActions })
            }
            this.setState({searchParams: value, auditActions});
        }else{
            let newValue =  value.filter(x => !currFilterValues.includes(x))[0];
            if(newValue !== undefined && newValue.type === "MOD"){
                const auditActions = this.packageAuditActions(newValue.AuditActions);
                this.setState({ auditActions })
            }
            let removedValue = currFilterValues.filter(x => !value.includes(x));
            if(removedValue.length === 0){
                let found = false;
                currFilterValues.forEach(function (item, key) {
                    if(item.type === newValue.type){
                        currFilterValues[key] = newValue;
                        found = true;
                    }
                });
                if(!found){
                    currFilterValues = value;
                }
                /*
                * I don't get why this needs to be done for it to work.
                * Js sucks!
                * * */
                const searchPayload = [...this.state.searchPayload];
                /*
                * */
                this.setState({ searchParams: currFilterValues, searchPayload });
            }else{
                this.setState({searchParams: value});
            }
        }
    };

    handleFilterModeChange = event => {
        const { users, auditModules, auditActions } = this.state;
        const filterMode = event.target.value;
        let searchPayload = users;
        if(filterMode === 1){
            searchPayload = users;
        }else if(filterMode === 2){
            searchPayload = auditModules;
        }else if(filterMode === 3){
            searchPayload = auditActions;
        }
        this.setState({ searchPayload, 'selectedFilterMode' : event.target.value });
    };

    findUser = (userId) => {
        const { users } = this.state;
        const check = users.find(item=>item.Id === userId);
        return (check) ? `${check.FirstName} ${check.LastName}` : 'Unknown User';
    };

    findModule = (moduleId) => {
        const { auditModules } = this.state;
        const check = auditModules.find(item=>item.ModuleId === moduleId);
        return (check) ? `${check.ModuleName}` : 'Unknown Module';
    };

    render() {
    const {
        pageRequesting, audits, totalCount,
        currentPage, pageSize,
         StartDate, EndDate,
        searchParams, filterModes, selectedFilterMode,
        searchPayload
    } = this.state;
    if(pageRequesting)
        return (
            <CircularProgress />
        );

    return (
      <div>
        <GridContainer>
          <SearchComponent
            StartDate={StartDate}
            EndDate={EndDate}
            onSearch={this.searchAudits}
            handleDateChange={this.handleDateChange}
            filterModes={filterModes}
            selectedFilterMode={selectedFilterMode}
            handleFilterModeChange={this.handleFilterModeChange}
            searchParams={searchParams}
            searchPayload={searchPayload}
            onValueChange={(e)=> this.handleMultiSelectChange(e)}
          />
        </GridContainer>
              <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                      <Card>
                          <CardBody>
                              {
                                  !pageRequesting && totalCount !== 0
                                  &&
                                  <RecordsTable
                                      currentPage={currentPage}
                                      pageSize={pageSize}
                                      fetchRecords={this.searchAudits}
                                      records={audits}
                                      totalCounts={totalCount}
                                      fetchMore={this.searchAudits}
                                      findUser={this.findUser}
                                  />
                              }
                              {
                                  !pageRequesting && totalCount === 0
                                  &&
                                  <GridContainer>
                                      <GridItem xs={12} sm={12} md={12}>
                                          <EmptyRecord message={'No audit record'}/>
                                      </GridItem>
                                  </GridContainer>
                              }
                          </CardBody>
                      </Card>
                  </GridItem>
              </GridContainer>

      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
    const { alert, requesting, users} = state;
    return {
        alert,
        requesting,
        users
    };
}
export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(AuditTrail)));




// WEBPACK FOOTER //
// ./src/views/AuditTrail/Index.jsx